import {get} from 'lodash';

import {EVENT_NAMES, SCREEN_NAMES} from '/enum/tealium.enum';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

import {getTaskNameForTealium} from '../ClientJourneyTask.util';

export const sendNavigationEvent =
  getTealiumUtilDefaultInstance().generateTrackEvent({
    eventName: EVENT_NAMES.onPageLoad,
  });

export const generateOnPress = ({
  item,
  isChecked,
  onTaskStatusChange,
  onShowTaskDetail,
  lastPaidRank,
}: any) => {
  return () => {
    onShowTaskDetail({
      taskItem: item,
      taskChecked: isChecked,
      onTaskStatusChange: onTaskStatusChange,
    });

    sendNavigationEvent({
      clientMilestone: getTaskNameForTealium(get(item, 'label', '')),
      currentScreenName: SCREEN_NAMES.profile,
      lastPaidRank: lastPaidRank,
    });
  };
};
